<template>
  <div>
    <div id="ecommerce-checkout-demo">
      <div class="w-full flex flex-col lg:flex-row md:flex-row">
        <div class="w-full lg:w-3/5 md:w-3/5">
          <Tabs :onClick="onClick" :active="active" />
          <div class="py-4">
            <form-wizard ref="checkoutWizard" color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null"
              :hide-buttons="true">
              <!-- STORE LIMITATION -->
              <div>
                <vs-card :key="limitation._id" v-for="limitation in limitationsList">
                  <p v-if="limitation.isAboveMax" class="text-base text-danger">
                    {{ limitation.display_message_max }}
                  </p>
                  <p v-if="limitation.isBelowMin" class="text-base text-danger">
                    {{ limitation.display_message_min }}
                  </p>
                  <p v-if="limitation.isBelowAmount" class="text-base text-danger">
                    {{ limitation.display_purchase_message_min }}
                  </p>
                </vs-card>
              </div>
              <!-- STORE LIMITATION -->
              <!-- OPENING ORDER Banner -->
              <div>
                <vs-card v-if="!meetOpeningOrder">
                  <p class="text-base text-danger">
                    Contact Fresh - opening order requirement does not meet.
                  </p>
                </vs-card>
              </div>
              <!-- OPENING ORDER Banner -->
              <!-- Inactive Items (Expandable) -->
               <div v-if="active === 1 && inactiveCartItems.length > 0" class="border border-gray-300 p-4 rounded-md bg-gray-100">
                <div class="flex items-center">
                  <div >
                    <button @click="removeAllInactive"
                      class=" bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 border-none">
                      Remove all inactive product/s ({{ inactiveCartItems.length }})
                    </button>
                  </div>
                  <div v-if="inactiveCartItems.length > 1" class="ml-2 cursor-pointer" @click="toggleInactiveItems">
                    <h6 class="font-semibold mb-1 hover:text-primary">
                      <span v-if="!showInactive" class="text-primary">(Show More)</span>
                      <span v-if="showInactive" class="text-primary">(Show Less)</span>
                    </h6>
                  </div>
                </div>
                <div class="items-list-view pt-4">
                  <div v-for="item in limitedInactiveItems" :key="item._id" class="mb-4">
                    <checkout-list-view
                    :item="item"
                    :isHidden="true"
                    :discounts="discountsArray"
                    :hasClinicDiscount="hasClinicDiscount"
                    class="mb-4"
                    :isDoctorStore="isDoctorStore"
                    :promo="applicablePromo"
                    @fetchCartItems="getCartItems">
                    <!-- SLOT: ITEM META -->

                    <template slot="item-meta">
                      <h6 class="item-name font-semibold mb-1 cursor-pointer hover:text-primary" @click="
                        $router
                          .push({
                            name: 'ecommerce-item-detail-view',
                            params: { item_id: item._id },
                          })
                          .catch(() => { })
                      ">
                        {{ item.name }}
                      </h6>
                      <p class="text-sm mb-2">
                        By
                        <span class="font-semibold cursor-pointer">{{
                            item.brand
                        }}</span>
                      </p>
                      <p class="text-success text-sm">In Stock</p>

                      <br />
                      <span class="text-danger" style="font-size: 0.75em">{{
                          errors.firstById(item._id)
                      }}</span>
                    </template>

                    <!-- SLOT: ACTION BUTTONS -->
                    <template slot="action-buttons">
                      <div class="w-full lg:w-auto flex flex-row lg:flex-col justify-end items-end lg:justify-none">
                        <vs-input-number
                          v-if="!item.bundleItems.length"
                          v-validate="'required'"
                          class="inputNumber"
                          max="999"
                          min="1"
                          :is-disabled="disableInput || item.patient"
                          :disabled="disableInput || item.patient"
                          v-model.number="item.quantity"
                          type="number"
                          @input="increase(item)"
                          @change="increase(item)"
                          @focusout = "item.quantity = item.quantity|| 1"
                        />
                        <div v-else class="mx-10 px-8 my-8"></div>
                      </div>
                    </template>
                  </checkout-list-view>
                  </div>
                </div>
              </div>
              <!-- Active Items -->
              <div v-if="active === 1">
                <div class="items-list-view pt-2" v-for="item in cartItems" :key="item._id">
                  <checkout-list-view
                    :item="item"
                    :discounts="discountsArray"
                    :hasClinicDiscount="hasClinicDiscount"
                    class="mb-4"
                    :isDoctorStore="isDoctorStore"
                    :promo="applicablePromo"
                    @fetchCartItems="getCartItems">
                    <!-- SLOT: ITEM META -->
                    <template slot="remove">
                      <div
                          class="w-1/2 lg:w-32 flex items-center justify-center"
                          >
                          <x-icon size="1.5x" class="cursor-pointer" @click="removeItemFromCart(item)"></x-icon>
                        </div>
                    </template>
                    <template slot="item-meta">
                      <h6 class="item-name font-semibold mb-1 cursor-pointer hover:text-primary" @click="
                        $router
                          .push({
                            name: 'ecommerce-item-detail-view',
                            params: { item_id: item._id },
                          })
                          .catch(() => { })
                      ">
                        {{ item.name }}
                      </h6>
                      <p class="text-sm mb-2">
                        By
                        <span class="font-semibold cursor-pointer">{{
                            item.brand
                        }}</span>
                      </p>
                      <p class="text-success text-sm">In Stock</p>

                      <br />
                      <span class="text-danger" style="font-size: 0.75em">{{
                          errors.firstById(item._id)
                      }}</span>
                    </template>

                    <!-- SLOT: ACTION BUTTONS -->
                    <template slot="action-buttons">
                      <div class="w-full lg:w-auto flex flex-row lg:flex-col justify-end items-end lg:justify-none">
                        <vs-input-number
                          v-if="!item.bundleItems.length"
                          v-validate="'required'"
                          class="inputNumber"
                          max="999"
                          min="1"
                          :is-disabled="disableInput || item.patient"
                          :disabled="disableInput || item.patient"
                          v-model.number="item.quantity"
                          type="number"
                          @input="increase(item)"
                          @change="increase(item)"
                          @focusout = "item.quantity = item.quantity|| 1"
                        />
                        <div v-else class="mx-10 px-8 my-8"></div>
                      </div>
                    </template>
                  </checkout-list-view>
                </div>
              </div>
              <div v-if="active === 2">
                <vx-card title="Shipping Details" subtitle="" class="mb-base">
                  <form data-vv-scope="add-new-address" class="add-new-address-form">
                    <p class="pb-2 font-semibold">Delivery Address</p>
                    <p>{{ shippingDetails.address.displayAddress }}</p>
                    <p class="pt-5 font-semibold">Days to Accept Deliveries</p>
                    <p class="text-sm italic pb-5">Note: All deliveries occur between 9 AM – 5 PM</p>
                    <delivery-operating-days
                      ref="deliveryOperatingDays"
                      :value="operations"
                      @input="val => (operations = { ...val })"
                    />
                    <div class="vx-row hidden">
                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input data-vv-as="field" name="clinicName" label="Clinic Name:"
                          v-model="shippingDetails.clinicName" class="w-full mt-5" disabled />
                      </div>

                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input name="email" label="Email:" v-model="shippingDetails.email" class="w-full mt-5"
                          disabled />
                      </div>
                    </div>

                    <div class="vx-row hidden">
                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input name="displayAddress" label="Address:" v-model="shippingDetails.address.displayAddress"
                          class="w-full mt-5" disabled />
                      </div>

                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input name="postCode" label="Post Code:" v-model="shippingDetails.address.postCode"
                          class="w-full mt-5" disabled />
                      </div>
                    </div>

                    <div class="vx-row hidden">
                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input v-validate="'required'" name="state" label="State:"
                          v-model="shippingDetails.address.state" class="w-full mt-5" disabled />
                      </div>

                      <div class="vx-col sm:w-1/2 w-full">
                        <vs-input name="suburb" label="Suburb:" v-model="shippingDetails.address.suburb"
                          class="w-full mt-5" disabled />
                      </div>
                    </div>

                    <div v-if="$isAuRegion()">
                      <p class="mt-10">
                        If you wish to change your delivery address please contact
                        fresh clinics.
                      </p>
                      <p class="mt-4">info@freshclinics.com.au</p>
                    </div>
                  </form>
                </vx-card>
              </div>
              <div v-if="active === 3">
                <div class="relative">
                  <div class="bg-white flex flex-col roundex-lg shadow-lg rounded-lg">
                    <h4 class="px-6 pt-4 pb-2">Payment options</h4>
                    <h5 class="px-6 pb-2 text-base font-normal">Selected Payment Methods</h5>
                    <div>
                      <ul>
                        <li v-for="(card, index) in paymentMethods" :key="index">
                          <div v-if="card.isPaymentTerm" class="flex items-start space-x-3 p-4 px-6">
                            <div>
                              <vs-radio v-model="selectedPayment" :vs-value="
                                card.value
                              " />
                            </div>
                            <div  >
                              <p class="font-medium">{{ card.text }}</p>
                              <p class="text-sm mb-1">You will receive an email with an invoice.</p>
                            </div>
                          </div>
                          <div v-else-if="radioButtonEnabled(card.type, card.status)" class="flex items-start space-x-3 p-4 px-6">
                            <div v-if="radioButtonEnabled(card.type, card.status)">
                              <vs-radio v-model="selectedPayment" :vs-value="paymentMethodKey(card)" />
                            </div>
                            <div v-if="card.type === 'CreditCard' && clinicPaymentOptions.some(e => e === 'creditCard')" class="flex-1 leading-none flex flex-col space-y-2">
                              <p class="font-medium">{{ card.brand }}</p>
                              <p class="text-sm mb-1">XXXX XXXX XXXX {{ card.last4 }}</p>
                              <p class="text-sm mb-1">
                                {{ card.exp_month }} /
                                {{ card.exp_year }}
                              </p>
                            </div>
                            <div v-if="card.type === 'BankAccount' && clinicPaymentOptions.some(e => e === 'DebitCard')" class="flex-1 leading-none flex flex-col space-y-2">
                              <p class="font-medium">{{ card.accountHolderName }}</p>
                              <p class="text-sm mb-1">{{ card.accountHolderEmail }}</p>
                              <p class="text-sm mb-1">
                                {{ card.bsb }} /
                                {{ card.accountNumber }}
                              </p>
                            </div>
                            <!-- No separate gate needed here — this only renders
                            inside the outer div's v-else-if="radioButtonEnabled(...)"
                            above, which already requires the clinicPaymentOptions
                            entitlement (FRH-747). -->
                            <div v-if="card.type === 'PayTo'" class="flex-1 leading-none flex flex-col space-y-2">
                              <p class="font-medium">{{ card.accountHolderName || 'PayTo' }}</p>
                              <p class="text-sm mb-1" v-if="card.payId">{{ card.payId }}</p>
                              <p class="text-sm mb-1" v-else-if="card.bsb || card.accountNumber">{{ card.bsb }} / {{ card.accountNumber }}</p>
                              <!-- FRH-745: a Pending account carries no
                              identifying detail yet (only known once Stripe
                              resolves the setup) — without this, retrying a
                              failed setup more than once renders several
                              byte-identical "PayTo / Pending" rows with no
                              way to tell them apart. -->
                              <p
                                class="text-sm mb-1"
                                v-else-if="formatPayToAddedDate(card.createdAt)"
                              >Added {{ formatPayToAddedDate(card.createdAt) }}</p>
                              <p class="text-sm mb-1">{{ card.status }}</p>
                              <!-- FRH-745: disclosed on the option itself,
                              not just in the post-submit toast — confirming
                              with a still-Pending account holds the order
                              rather than paying for it immediately. -->
                              <p class="text-sm mb-1 text-warning" v-if="card.status === 'Pending'">
                                Your order will be placed on hold until your bank approves this PayTo agreement.
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="border pb-6 pl-2" style="border-top: solid 1px #e0e0e0">
                      <!-- FRH-745: this modal's PayTo tab only ever saves a
                      new account — it never pays for the order itself. The
                      saved (possibly still Pending) account then shows up in
                      the radio list above, and this page's own Confirm
                      button is what submits. -->
                      <AddPaymentMethod
                        v-if="canCheckout"
                        :stripePublishableKey="stripePublishableKey"
                        :totalPrice="totalPrice"
                        :financialDetails="financialDetails"
                        :isNewClinicBankAccount="isNewClinicBankAccount"
                        :shippingDetails="shippingDetails"
                        :paymentEmail="orgOwnerEmail"
                        :clinicId="clinicId"
                        :saveCreditCard="'Add Payment Method'"
                        @token-created="tokenCreated"
                        @clinic-bank-payment-success="clinicBankPaymentSuccess"
                        @payto-setup-success="payToSetupSuccess"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form-wizard>
          </div>
        </div>
        <div class="w-full lg:w-2/5 md:w-2/5 lg:px-4 md:px-4">
          <div v-if="active === 1">
            <div v-if="hasOrganization" class="w-full bg-white p-5 rounded-lg mb-5 shadow">
              <SwapClinic :title="thisCartText" />
            </div>
            <vx-card>
              <div v-if="getTotalSavings > 0" class="flex items-center justify-between mb-3">
                <span class=" text-lg ">Don't pay list price</span>
                <span class=" text-2xl line-through">{{ currency }} ${{ totalListPrice | formatDecimals }}</span>
              </div>

              <div v-if="totalSavings > 0" class="savings p-3 flex items-center justify-center mb-3">
                <div>
                  <img
                    class=" w-8 mr-4 fill-current text-primary"
                    :src="require('../../../../public/Group-543.svg')"
                  />
                </div>
                <div class=" font-medium text-xl">
                  You're saving ${{ totalSavings | formatDecimals }} by using Fresh Clinics
                </div>
              </div>

              <vs-divider v-if="getTotalSavings > 0"/>


              <div class="flex items-center justify-between">
                <span class="">Sub Total</span>
                <span class=" price-text text-2xl">{{ currency }} ${{ subTotal - getTotalSavings - totalPromo | formatDecimals }}</span>
              </div>
              <vs-divider/>
              <CheckoutVoucher :voucherData="voucher" @updateVoucher="voucher = $event" :totalBalance="balanceBeforeVoucher" :totalQty="cartItemsQty" :retoolDiscounts="discountsArray" :shippingDiscounts="deliveryFees" />
              <vs-divider/>
              <div class="flex items-center justify-between mb-2">
                <span class="text-gray-500">Sub Total</span>
                <span>{{ currency }} ${{ subTotal | formatDecimals }}</span>
              </div>
              <div class="flex justify-between mb-2" v-for="discountItem in discountsArray" :key="discountItem._id">
                <span class="text-grey">
                  {{ discountItem.rule.discount_title }}</span>
                <span class="text-success">{{ currency }} ${{
                    discountItem.totalDiscount | formatDecimals
                }}
                </span>
              </div>
              <div class="flex justify-between mb-2" v-for="promo in applicablePromo" :key="promo._id">
                <span class="text-grey">
                  {{ promo.rule.discount_title }}</span>
                <span class="text-success">{{ currency }} ${{
                    promo.totalPromo | formatDecimals
                }}
                </span>
              </div>
              <div class="flex justify-between mb-2" v-for="freeShippingItem in freeShippingArray"
                :key="freeShippingItem._id">
                <span class="text-grey">
                  {{ freeShippingItem.free_shipping_name }}</span>
                <span class="text-success">{{ currency }} $-{{
                    freeShippingItem.totalDiscount | formatDecimals
                }}
                </span>
              </div>

              <div class="flex justify-between mb-2" v-for="(item, index) in deliveryFees" :key="index">
                <span class="delivery-text">{{ item.supplierName }}</span>
                <span class="price-text">{{ currency }} ${{ item.amount | formatDecimals }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Delivery fee total</span>
                <span class="text-success">{{ currency }} ${{ deliveryCharge | formatDecimals }}</span>
              </div>

              <vs-divider />


              <div class="flex items-center justify-between mb-2">
                <span class=" font-bold text-sm delivery-text">FEES</span>
              </div>

              <div class="flex justify-between mb-2" v-if="showCreditCardPaymentCharge">
                <span class="text-grey w-3/5">
                  2% Card Transaction Fee</span>
                <span class="text-success">{{ currency }} ${{
                    creditCardTransactionFee | formatDecimals
                }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="showPaymentEfficiencyBenefit">
                <span class="text-grey w-3/5">Payment Efficiency Discount</span>
                <span class="text-success">-{{ currency }} ${{
                    paymentEfficiencyBenefit | formatDecimals
                }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="!isUS">
                <span class="text-grey">GST (10%)</span>
                <span>{{ currency }} ${{ gstTotal | formatDecimals }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="isUS">
                <span class="text-grey">Taxes</span>
                <span>{{ currency }} ${{ tax | formatDecimals }}</span>
              </div>

              <vs-divider v-if="voucher" />
              <div class="flex items-center justify-between mb-2" v-if="voucher">
                <span class=" font-bold text-sm delivery-text">VOUCHER DISCOUNT</span>
              </div>
              <div class="flex justify-between mb-2" v-if="voucher">
                <span class="flex items-center gap-2 price-text">
                  <feather-icon icon='TagIcon' svgClasses='h-4 w-4' />{{ voucher.discount_title }}
                </span>
                <span>&minus;{{ currency }} ${{ voucherPrice | formatDecimals }}</span>
              </div>

              <vs-divider />

              <div class="flex justify-between font-semibold mb-3">
                <span>Total</span>
                <span>{{ currency }} ${{ totalPrice | formatDecimals }}</span>
              </div>

             <div v-if="inactiveCartItems.length > 0" class="flex py-5">
              <feather-icon icon='AlertTriangleIcon' svgClasses='h-7 w-7' class='ml-1 text-yellow-600 pr-2' />
              <span class=" text-sm">Please remove inactive products to proceed!</span>
             </div>
              <vs-button class="w-full" :disabled="!validateForm || cartItems.length <= 0 || disableNext || inactiveCartItems.length > 0"
                @click="onClick(2)">NEXT
              </vs-button>
            </vx-card>

            <vx-card>
              <p class="font-semibold mb-3">Add Notes</p>
              <vs-textarea data-vv-as="field" name="notes" :maxlength="max" v-model="shippingDetails.notes"
                class="w-full h-20 mt-5"></vs-textarea>
            </vx-card>
          </div>
          <div v-if="active === 2">
            <div v-if="hasOrganization" class="w-full bg-white p-5 rounded-lg mb-5 shadow">
              <SwapClinic :title="thisCartText" />
            </div>
            <vx-card :title="shippingDetails.clinicName">
              <div>
                <p>{{ shippingDetails.address.displayAddress }}</p>
              </div>

              <vs-divider />
              <vs-button class="w-full" :disabled="deliveryButtonDisabled || disableNext"
                @click="onClick(3)">Deliver to this Address
              </vs-button>

            </vx-card>
            <vx-card>
              <p class="font-semibold mb-3">Order Notes</p>
              <p class="font-regular mb-3 break-all">
                {{ shippingDetails.notes }}
              </p>
            </vx-card>
          </div>
          <div v-if="active === 3">
            <div v-if="hasOrganization" class="w-full bg-white p-5 rounded-lg mb-5 shadow">
              <SwapClinic :title="thisCartText" />
            </div>
            <vx-card>
              <p class="font-semibold mb-3" style="font-size: 16px">
                Price Details
              </p>

              <div class="flex items-center justify-between mb-2">
                <span class="text-gray-500">Sub Total</span>
                <span>{{ currency }} ${{ subTotal | formatDecimals }}</span>
              </div>
              <div class="flex justify-between mb-2" v-for="discountItem in discountsArray" :key="discountItem._id">
                <span class="text-grey">
                  {{ discountItem.rule.discount_title }}</span>
                <span class="text-success">{{ currency }} ${{
                    discountItem.totalDiscount | formatDecimals
                }}
                </span>
              </div>
              <div class="flex justify-between mb-2" v-for="promo in applicablePromo" :key="promo._id">
                <span class="text-grey">
                  {{ promo.rule.discount_title }}</span>
                <span class="text-success">{{ currency }} ${{
                    promo.totalPromo | formatDecimals
                }}
                </span>
              </div>
              <div class="flex justify-between mb-2" v-for="freeShippingItem in freeShippingArray"
                :key="freeShippingItem._id">
                <span class="text-grey">
                  {{ freeShippingItem.free_shipping_name }}</span>
                <span class="text-success">{{ currency }} $-{{
                    freeShippingItem.totalDiscount | formatDecimals
                }}
                </span>
              </div>

              <div class="flex justify-between mb-2" v-for="(item, index) in deliveryFees" :key="index">
                <span class="delivery-text">{{ item.supplierName }}</span>
                <span class="price-text">{{ currency }} ${{ item.amount | formatDecimals }}</span>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Delivery fee total</span>
                <span class="text-success">{{ currency }} ${{ deliveryCharge | formatDecimals }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="showCreditCardPaymentCharge">
                <span class="text-grey">2% Card Transaction Fee</span>
                <span class="text-success">{{ currency }} ${{
                    creditCardTransactionFee | formatDecimals
                }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="showPaymentEfficiencyBenefit">
                <span class="text-grey">Payment Efficiency Discount</span>
                <span class="text-success">-{{ currency }} ${{
                    paymentEfficiencyBenefit | formatDecimals
                }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="!isUS">
                <span class="text-grey">GST (10%)</span>
                <span>{{ currency }} ${{ gstTotal | formatDecimals }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="!isUS && voucher">
                <div class="flex items-center gap-2 text-grey">
                  <feather-icon icon='TagIcon' svgClasses='h-4 w-4' />{{ voucher.discount_title }}
                </div>
                <span>&minus;{{ currency }} ${{ voucherPrice | formatDecimals }}</span>
              </div>
              <div class="flex justify-between mb-2" v-if="isUS">
                <span class="text-grey">Taxes</span>
                <span>{{ currency }} ${{ tax | formatDecimals }}</span>
              </div>
              <vs-divider />

              <div class="flex justify-between font-semibold mb-3">
                <span>Total</span>
                <span>{{ currency }} ${{ totalPrice | formatDecimals }}</span>
              </div>
              <div
                class="flex justify-between font-semibold mb-3"
                v-if="isLoggedInSuperAdmin">
                <span>Send to Sage?</span>
                <vs-switch
                  name="sendToSage"
                  v-model="sendToSage"/>
              </div>
              <vs-button v-if="(paymentType || selectedPayment) && canCheckout" class="w-full"
                @click="sendToServer({ amount: totalPrice })" :disabled="isCheckoutButtonDisabled">
                <span v-if="shouldShowDoctorApprovalFlow">Send Requests</span>
                <span v-else-if="paymentDetails && paymentDetails.isPaymentTerm">Confirm</span>
                <span v-else>Confirm</span>
                </vs-button>
              <div v-if="(!paymentType && !selectedPayment) || !canCheckout"
                class="w-full p-3 text-center rounded text-white" style="background-color: #a0a0a0">
                <p v-if="hasOustanding">
                  Sorry! Your account has an outstanding product payment. Please
                  complete your payment before continuing.<br />
                  <span style="
                      padding-bottom: 2px;
                      border-bottom: solid 1px white;
                      cursor: pointer;
                    " @click="goToOrders()">Pay Now</span>
                </p>
                <span v-if="shouldShowDoctorApprovalFlow">Send Request</span>
                <p v-else-if="!hasOustanding">Confirm Payment</p>
              </div>
              <p v-if="shouldApplyOrderLimit && totalPrice > maxOrderLimitThreshold" class="text-red-600 mt-3" v-html="orderLimitMessage">
              </p>
            </vx-card>
            <vx-card>
              <p class="font-semibold mb-3">Order Notes</p>
              <p class="font-regular mb-3 break-all">
                {{ shippingDetails.notes }}
              </p>
            </vx-card>
          </div>
        </div>
      </div>
      <ImportantInformation v-if="orderApprovalFlowEnabled && $isAuRegion()" />
      <vs-popup class="holamundo" title="Outstanding Payment" :active.sync="popupActive2">
        <div class="flex flex-no-wrap">
          <div class="w-1/6 flex items-center justify-center">
            <vs-icon icon="clear" size="medium" bg="#f9d6d6" color="#b21f1e" round></vs-icon>
          </div>
          <div class="w-5/6">
            <p>
              Sorry! Your account has an outstanding product payment. Please
              complete your payment before continuing.
              <br />Need help? Call 1300 375 646
            </p>
          </div>
        </div>
        <div class="flex justify-between mt-5">
          <vs-button class="mr-4 mb-4" @click="popupActive2 = false">
            Close
          </vs-button>
          <vs-button class="mr-4 mb-4" @click="goToOrders()">
            Go to payment
          </vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { FormWizard } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { mapActions, mapMutations } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import { ORDER_COMPLETE_MESSAGES } from './orderCompleteConstants';
const CheckoutListView = () => import('./CheckoutListView.vue');
import Tabs from '../../../layouts/components/tabs/tabs.vue';
import { XIcon } from 'vue-feather-icons';
import SwapClinic from '../../components/shop/clinic.vue';
import StoreHelper from '../../../mixins/Store.vue';
import CheckoutHelper from '../../../mixins/Checkout.vue';
import CheckoutVoucher from '../../components/voucher/CheckoutVoucher.vue';
import { toFixed } from 'accounting-js';
import { currentUserIsDoctor } from '../../../globalHelpers/userRole';
import {
  CENTS_PER_DOLLAR,
  DISCOUNT_PRICE_LIST_PRICE,
  DISCOUNT_PRICE_DOCTOR_PRICE,
} from '../../../constants/price';
import {
  DEFAULT_ERROR_TITLE,
  DEFAULT_PAYMENT_ERROR_MESSAGE,
  PAYMENT_FAILED_TITLE,
} from '../../../constants/paymentErrors';

// Utils
import {
  trackEcommerceEvent,
  getCurrency,
  formatPriceValue,
  BEGIN_CHECKOUT_EVENT,
  VIEW_CART_EVENT,
  PURCHASE,
  ADD_PAYMENT_INFO,
  ADD_SHIPPING_INFO,
} from '../../../utils/gtag';
import ImportantInformation from './ImportantInformation.vue';
import DeliveryOperatingDays from '@/components/DeliveryOperatingDays.vue';
import { toPluralOperationsMap } from '../../../globalHelpers/string';
import AddPaymentMethod from '@/components/AddPaymentMethod.vue';
import { buildDeliveryFeeLines } from '@/utils/deliveryFeeGrouping';

export default {
  name: 'Checkout',
  inject: ['getRoleRouteName'],
  mixins: [StoreHelper, CheckoutHelper],
  data() {
    return {
      showInactive: false,
      stripe: null,
      hasOrganization: false,
      stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      saveCreditCard: true,
      selectedPayment: null,
      isSavedAddress: false,
      selectedMode: null,
      cardDetails: [],
      defaultCard: null,
      financialDetails: null,
      isNewClinicBankAccount: true,
      isAccessPaymentTerms: false,
      paymentMode: null,
      bankMode: null,
      popupActive: false,
      role: null,
      shippingDetails: {
        clinicName: '',
        address: {},
        email: '',
        notes: '',
      },
      card: {
        number: '',
        cvc: '',
        exp: '',
      },
      isCreditCard: false,
      max: 200,
      // TAB 3
      paymentType: null,
      popupActive2: false,
      firstLoad: true,
      maximumOrderLimit: false,
      haveMeetMaximumOrderLimit: false,
      active: 1,
      operations: {
        mondays: null,
        tuesdays: null,
        wednesdays: null,
        thursdays: null,
        fridays: null,
        saturdays: null,
        sundays: null,
      },
      deliveryButtonDisabled: true,
      isUS: process.env.VUE_APP_REGION !== 'AU',
      MAX_ORDER_LIMIT: (parseInt(process.env.VUE_APP_MAX_ORDER_LIMIT) || 30000) * CENTS_PER_DOLLAR, // Default: $30,000 in cents
      CENTS_PER_DOLLAR, // Expose constant for template use
      // Payment types that bypass the order limit (comma-separated, e.g., "CreditCard,PaymentTerms")
      ORDER_LIMIT_BYPASS_PAYMENT_TYPES: (process.env.VUE_APP_ORDER_LIMIT_BYPASS_PAYMENT_TYPES || 'CreditCard,PaymentTerms').split(',').map(type => type.trim()),
      isAU: process.env.VUE_APP_REGION === 'AU',
      currency: process.env.VUE_APP_CURRENCY,
      region: process.env.VUE_APP_REGION,
      paymentMethods: [],
      orgPaymentMethods: [],
      tax: 0,
      showCreditCard: false,
      showBankAccount: false,
      canCheckout: true,
      hasOustanding: false,
      showCreditCardPaymentCharge: false,
      showPaymentEfficiencyBenefit: false,
      paymentDetails: null,
      clinicId: sessionStorage.getItem('doctorClinicSelectedClinic'),
      deliveryFees: [],
      cartItems: [],
      inactiveCartItems: [],
      disableInput: false,
      isCreditCardFeeExempt: false,
      isMobileView: null,
      clinicApprovalFlowSetting: false, // Store clinic's setting for computed property
      clinicPaymentOptions: [],
      sendToSage: true,
      orgOwnerEmail: '',
      voucher: null,
      voucherPrice: 0,
      totalHistorySavings: 0,
      isDoctorStore: false,
      thisCartText: 'This cart is for:',
      tracked: false, // Use to check whether the event has been tracked since cartItems from store are being watched multiple times.
      orderApprovalFlowEnabled: false,
    };
  },
  computed: {
    shouldShowDoctorApprovalFlow() {
      // 1. If user is doctor -> false
      // 2. If user is nurse and no S4 in cart -> false
      // 3. If user is nurse and cart has S4 -> true (if clinic has it enabled)
      const isDoctor = currentUserIsDoctor();
      
      if (isDoctor) {
        return false;
      }
      
      // For nurses: check cart items directly from store for S4 products
      const cartItems = (this.$store.state.eCommerce && this.$store.state.eCommerce.cartItems) || [];
      const hasS4InCart = cartItems.some(item => {
        // Check multiple possible property paths
        return item.s4Medication === true || 
               (item.product && item.product.s4Medication === true);
      });
      
      // Only show approval flow if clinic has it enabled AND cart has S4 products
      return this.clinicApprovalFlowSetting && hasS4InCart;
    },
    totalSavings() {
      let saving = this.getTotalSavings > 0 ? this.getTotalSavings : 0;

      if (this.totalPromo > 0) saving += this.totalPromo;

      return saving;
    },
    couponsList() {
      return this.discountsArray.length
        ? this.discountsArray.map(discount => discount.rule.discount_title).join(', ')
        : null;
    },
    // FRH-745: a PayTo account that isn't Active yet means checkoutPayment
    // holds the order rather than charging it — the account may activate a
    // moment later on the backend's own retry race, but from here there's no
    // way to know that yet, so treat it as pending rather than risk telling
    // the clinic their order is paid when it might not be.
    isPayToHold() {
      return this.paymentType === 'PayTo' && (!this.paymentDetails || this.paymentDetails.status !== 'Active');
    },
    orderLimitMessage() {
      const maxLimit = (this.MAX_ORDER_LIMIT / CENTS_PER_DOLLAR).toLocaleString('en-US', { maximumFractionDigits: 0 });
      return `For orders over $${maxLimit} ${this.currency}, please reach out to your Account Manager or our Customer Service team at <a href="mailto:orders@freshclinics.com">orders@freshclinics.com</a>`;
    },
    shouldApplyOrderLimit() {
      // Don't apply limit for configured payment types (e.g., credit card or payment terms)
      // Still apply limit for debit card, bank account, or other payment methods
      if (!this.paymentDetails) return true; // Apply limit if no payment selected
      
      const paymentType = this.paymentDetails.type;
      const isPaymentTerms = this.paymentDetails.isPaymentTerm === true;
      
      // Check if payment type is in the bypass list
      const shouldBypass = this.ORDER_LIMIT_BYPASS_PAYMENT_TYPES.includes(paymentType) || 
                          (isPaymentTerms && this.ORDER_LIMIT_BYPASS_PAYMENT_TYPES.includes('PaymentTerms'));
      
      // Skip limit for configured payment types, apply limit for others
      return !shouldBypass;
    },
    maxOrderLimitThreshold() {
      // Subtract 1 cent for comparison (e.g., 29999 for 30000 limit)
      return this.MAX_ORDER_LIMIT - CENTS_PER_DOLLAR;
    },
    isCheckoutButtonDisabled() {
      // Disable checkout button if order is over 30k AND using bank account payment
      const isBankAccountPayment = this.paymentDetails && this.paymentDetails.type === 'BankAccount';
      const exceedsOrderLimitWithBankAccount = isBankAccountPayment && this.totalPrice > this.maxOrderLimitThreshold;
      
      // Keep other existing conditions
      const exceedsOrderLimit = this.shouldApplyOrderLimit && this.totalPrice > this.maxOrderLimitThreshold;
      // FRH-732/FRH-736: block submit until the surcharge and benefit lookups
      // resolve, so the order can never be built from pre-load (potentially
      // stale) fee/benefit state.
      return exceedsOrderLimitWithBankAccount || exceedsOrderLimit || !this.meetOpeningOrder || !this.hasPaymentTermSetup || this.disableNext || this.disabledClinic || !this.surchargeStatusLoaded || !this.benefitStatusLoaded;
    },

    limitedInactiveItems() {
      return this.showInactive ? this.inactiveCartItems : this.inactiveCartItems.slice(0, 1);
    },
    checkDeviceType() {
      const isMobileApp = localStorage.getItem('iframe-view');
      if (isMobileApp) {
        return {
          'type': 'mobile',
        };
      } else {
        if (window.innerWidth <= 640) { // Breakpoint for mobile view
          return {
            'type': 'mobileweb',
          };
        }
        return {
          'type': 'web',
        };
      }
    },
    cartItemsQty() {
      let items = this.$store.state.eCommerce.cartItems;
      let count = 0;

      items.map(item => {
        count += item.quantity;
      });

      return count;
    },
    hasPaymentTermSetup() {
      const hasCCorDebit = this.clinicPaymentOptions.length && this.clinicPaymentOptions.some(e => ['creditCard', 'DebitCard'].includes(e));
      if (!this.paymentDetails) return false;
      if (this.paymentDetails.isPaymentTerm) return true;
      // FRH-747: PayTo is now gated on clinicPaymentOptions, same as
      // radioButtonEnabled — otherwise the Next button could unlock off a
      // PayTo selection the clinic isn't actually entitled to. FRH-745: a
      // Pending mandate is allowed too, matching radioButtonEnabled — the
      // clinic can select and confirm with one, checkoutPayment holds the
      // order instead of charging it until the mandate resolves.
      if (this.paymentDetails.type === 'PayTo') {
        return ['Active', 'Pending'].includes(this.paymentDetails.status) && this.isPayToEnabled();
      }

      return this.paymentDetails && ['CreditCard', 'BankAccount'].includes(this.paymentDetails.type) && hasCCorDebit;
    },
    disabledClinic() {
      const state = this.$store.state;
      if(state.operations === null  && state.clinicId === null) {
        const clinicId = sessionStorage.getItem('doctorClinicSelectedClinic');
        const clinic = state.clinic.find(clinic => `${clinic._id}` === `${clinicId}`);
        return !clinic._id && !clinic.clinicOpeningHours;
      }

      return !state.clinicId && !state.operations;
    },

    meetOpeningOrder() {
      let isMeet = true;
      if (!this.$isNZRegion()) {
        const matchedSuppliers = {};
        const minimumValue = this.minimumRequirement && Object.keys(this.minimumRequirement).length ? +this.minimumRequirement.value : 0;
        this.cartItems.map((item) => {
          const { inventory } = item;
          const isSameSupplier = this.openingOrderSuppliers.find((i) => i === inventory.managedBy);
          if (!item.openingOrder && isSameSupplier) {
            if (matchedSuppliers[inventory.managedBy]) {
              matchedSuppliers[inventory.managedBy] = matchedSuppliers[inventory.managedBy] + (item.quantity * item.price);
            } else {
              matchedSuppliers[inventory.managedBy] = item.quantity * item.price;
            }
          }
        });

        Object.keys(matchedSuppliers).map((key) => {
          if (matchedSuppliers[key] < minimumValue) isMeet = false;
        });
      }
      return isMeet;
    },
    totalPriceDiscountAndDeliveryCharge() {
      /**
       * If voucher is applied,
       * remove delivery charge from computation
       * since it's already computed in the subTotal 
       */
      if (this.voucher && !this.voucher.applyAfterGST) {
        return (
          this.subTotal -
          this.totalDiscounts -
          this.totalPromo
        );
      }

      return (
        this.subTotal -
        this.totalDiscounts -
        this.totalPromo +
        this.deliveryCharge
      );
    },
    balanceBeforeVoucher() {
      const creditCardFee = this.creditCardTransactionFee;
      const benefit = this.paymentEfficiencyBenefit;
      let total = this.totalPriceDiscountAndDeliveryCharge + creditCardFee - benefit;
      if (this.region === 'AU') {
        total = total + this.gstTotal;
      }
      return Math.round(total);
    },
    totalPrice() {
      const creditCardFee = this.creditCardTransactionFee;
      const benefit = this.paymentEfficiencyBenefit;
      let total = this.totalPriceDiscountAndDeliveryCharge + creditCardFee - benefit;
      if (this.region === 'AU') {
        total = total + this.gstTotal;
      }
      if (this.voucher) {
        total = total - this.voucherPrice;
        if (total < 0) {
          total = 0.00;
        }
      }
      return Math.round(total);
    },
    gstTotal() {
      // GST base:
      // - If there are taxable items: TAXABLE subtotal (after discounts/promos) + delivery + actual card fee
      // - If there are NO taxable items: delivery + actual card fee only
      // The benefit is calculated on the whole merchandise base, including
      // any GST-free items, but only the taxable share of it should reduce
      // the taxable GST base — subtracting the full benefit here understates
      // GST on any cart mixing taxable and GST-free items, and can even go
      // negative on an all-GST-free cart with delivery (found via review;
      // mirrors the same fix in storeTransformer.js's apportionBenefitGST).
      const taxableSubtotal = this.getTaxableSubtotal();

      const delivery = this.deliveryCharge || 0;
      const cardFee = this.creditCardTransactionFee || 0;
      const benefit = this.paymentEfficiencyBenefit || 0;
      const benefitBase = this.paymentEfficiencyBenefitBase;
      const taxableShareOfBenefit = benefitBase > 0 ? benefit * (taxableSubtotal / benefitBase) : 0;

      // If nothing taxable and no delivery, GST is zero (card fee alone should not be taxable)
      if (!taxableSubtotal && !delivery) {
        return 0;
      }

      // When there is a taxable subtotal, include it in the GST base; otherwise only delivery + card fee
      const baseAmount = Math.max(0, (taxableSubtotal || 0) + delivery + cardFee - taxableShareOfBenefit);

      // Calculate 10% GST on the total
      const gst = (baseAmount * 0.1);
      return toFixed(gst / CENTS_PER_DOLLAR, 2) * CENTS_PER_DOLLAR;
    },
    getActualSubTotal() {
      return 0;
    },
    freeShippingTotal() {
      return _.sum(
        this.freeShippingArray.map((freeshipping) => freeshipping.totalDiscount)
      );
    },
    deliveryCharge() {
      return this.getDeliveryCharge() - this.freeShippingTotal;
    },
    creditCardTransactionFee() {
      // FRH-732: retired in AU from 1 Oct 2026 (RBA), still charged elsewhere.
      if (!this.cardSurchargeActive) return 0;

      let searchResult = this.paymentMethods.filter(
        ({ paymentMethodId, type }) =>
          paymentMethodId === this.selectedPayment && type === 'CreditCard'
      );

      if (searchResult.length <= 0) {
        searchResult = this.paymentMethods.filter(
          ({ cardId, type }) =>
            cardId === this.selectedPayment && type === 'CreditCard'
        );
      }

      if (searchResult.length && searchResult[0].type === 'CreditCard' && !this.isCreditCardFeeExempt) {
        const creditCardCharge = (this.totalPriceDiscountAndDeliveryCharge * 2) / CENTS_PER_DOLLAR;
        return creditCardCharge;
      }
      return 0;
    },
    paymentEfficiencyBenefit() {
      // PayTo (Active or Pending) and Direct Debit, plus Payment Terms while the
      // server's terms flag is on, in place of the retired 2% card surcharge.
      // Matches the server; the rate comes from the server and is higher for
      // key accounts. paymentDetails already reflects the selected method
      // (populatePaymentDetails runs on every selectedPayment change).
      if (!this.paymentEfficiencyBenefitActive) return 0;
      if (!this.paymentDetails) return 0;
      const isPaymentTerms = this.paymentDetails.isPaymentTerm === true && this.paymentTermsBenefitActive;
      if (!['PayTo', 'BankAccount'].includes(this.paymentDetails.type) && !isPaymentTerms) return 0;

      const benefit = this.paymentEfficiencyBenefitBase * (this.paymentEfficiencyBenefitRate || 0);
      return toFixed(benefit / CENTS_PER_DOLLAR, 2) * CENTS_PER_DOLLAR;
    },
    paymentEfficiencyBenefitBase() {
      // Merchandise only, delivery fee excluded, matching the server. subTotal
      // folds delivery in when a pre-GST voucher is applied, so take it back out.
      const deliveryInSubTotal = this.voucher && !this.voucher.applyAfterGST ? this.deliveryCharge || 0 : 0;
      // A pre-GST voucher bigger than the merchandise would make this negative, and
      // the benefit must never add to the total.
      return Math.max(0, this.subTotal - deliveryInSubTotal - this.totalDiscounts - this.totalPromo);
    },
    discountTotal() {
      if (this.isAU) {
        return (
          this.subTotal +
          this.deliveryCharge +
          this.creditCardTransactionFee +
          this.gstTotal -
          this.totalPrice
        );
      } else {
        return 0;
      }
    },
    subTotal() {
      let temp = this.cartSubTotal;
      if (this.voucher && !this.voucher.applyAfterGST) {
        temp = (temp + this.deliveryCharge) - this.voucherPrice;
        if (temp < 0) {
          temp = 0.00;
        }
      }
      return temp;
    },
    totalListPrice() {
      let totalListPrice = 0;
      this.cartItems.map(item => {
        if (this.isDiscounted(item)) {
          totalListPrice = totalListPrice + (((item.listPrice) * item.quantity));
        }
        else {
          totalListPrice = totalListPrice + (((item.price) * item.quantity));
        }
      });
      return totalListPrice;
    },
    getTotalSavings() {
      let totalDiscount = 0;

      this.discountsArray.map(discount=> {
        totalDiscount = totalDiscount + discount.totalDiscount;
      });
      return totalDiscount;
    },
    isInWishList() {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId);
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  async created() {
    this.getClinicPaymentDetails();
    this.getClinicDetails();
    this.shippingDetails = await this.getUserDetail();
    this.isUS = process.env.VUE_APP_REGION === 'US';

    if (this.$store.state.clinic && this.$store.state.clinic.length) {
      this.showCreditCard = this.$store.state.clinic[0].paymentTypes.includes('creditCard');
      this.showBankAccount = this.$store.state.clinic[0].paymentTypes.includes('DebitCard');
    }

    this.canCheckoutChecker();
    if (this.isUS) this.getUSTax();
    const orderId = localStorage.getItem('orderId');
    if (orderId) {
      this.reOrderItems(orderId);
    }
  },
  watch: {
    voucher: {
      handler(val) {
        if (val) {
          if (val.discount_type === 'fix') {
            this.voucherPrice = val.discount_value * CENTS_PER_DOLLAR;
          } else {
            if (val.applyAfterGST) {
              this.voucherPrice = (val.discount_value / CENTS_PER_DOLLAR) * this.totalPrice;
            } else {
              this.voucherPrice = (val.discount_value / CENTS_PER_DOLLAR) * (this.subTotal - this.getTotalSavings);
            }
          }
        } else {
          this.voucherPrice = 0;
        }
      },
      deep: true,
    },
    '$store.state.eCommerce.inactiveCartItems': {
      handler(val) {
        let inactiveCartItems = JSON.parse(JSON.stringify(val.slice().reverse()));
        this.inactiveCartItems = inactiveCartItems;
      },
      immediate: true,
    },
    '$store.state.eCommerce.cartItems': {
      handler(val) {
        let itemsInCart = JSON.parse(JSON.stringify(val.slice().reverse()));

        itemsInCart = itemsInCart.map((item) => {
          let superAdminPrice = item.price;
          let superAdminDiscountPrice = 0;

          if (item.hasOwnProperty('superAdminPrice')) superAdminPrice = item.superAdminPrice;
          if (item.hasOwnProperty('superAdminDiscountPrice')) {
            superAdminDiscountPrice = item.superAdminDiscountPrice;
            item.superAdminDiscountPriceFrom = 'db';
          }

          if (this.isLoggedInSuperAdmin) {
            item.superAdminPrice = superAdminPrice / CENTS_PER_DOLLAR;
            item.superAdminDiscountPrice = superAdminDiscountPrice / CENTS_PER_DOLLAR;
          }

          return item;
        });
        this.cartItems = itemsInCart;

        // Track the ecommerce events only once when cartItems are fetched from
        // Vue store. This is to prevent multiple tracking of the same event.
        if (val.length > 0 && !this.tracked) {
          trackEcommerceEvent(VIEW_CART_EVENT, {
            currency: getCurrency(),
            value: formatPriceValue(this.cartSubTotal),
            items: this.cartItems.map((item) => ({
              item_id: item._id,
              item_name: item.name,
              price: formatPriceValue(item.price),
              quantity: item.quantity,
            })),
          });

          trackEcommerceEvent(BEGIN_CHECKOUT_EVENT, {
            currency: getCurrency(),
            value: formatPriceValue(this.cartSubTotal),
            coupon: this.couponsList,
            items: this.cartItems.map((item) => ({
              item_id: item._id,
              item_name: item.name,
              price: formatPriceValue(item.price),
              quantity: item.quantity,
            })),
          });
          this.tracked = true;
        }
      },
      immediate: true,
    },
    creditCardTransactionFee: function (val) {
      this.showCreditCardPaymentCharge = val > 0;
    },
    paymentEfficiencyBenefit: function (val) {
      this.showPaymentEfficiencyBenefit = val > 0;
    },
    selectedPayment: function (val) {
      this.populatePaymentDetails(val);
      // Use $nextTick to ensure paymentDetails is updated before checking
      this.$nextTick(() => {
        // Reset limit flag when switching to a payment method that doesn't require limit
        if (!this.shouldApplyOrderLimit) {
          this.maximumOrderLimit = false;
          this.haveMeetMaximumOrderLimit = false;
        } else {
          // When switching TO a payment method that requires limit, check if we should show modal
          if (Math.round(this.totalPrice) > this.maxOrderLimitThreshold && !this.haveMeetMaximumOrderLimit) {
            this.maximumOrderLimit = true;
            this.haveMeetMaximumOrderLimit = true;
          }
        }
      });
    },
    operations: {
      deep: true,
      handler(value, oldValue) {
        if (value === oldValue) return;
        const isDisabled = Object.keys(value).filter(
          (k) => !value[k] || value[k] === ''
        );
        this.deliveryButtonDisabled = !(isDisabled.length <= 0);
      },
    },
    popupActive: function (val) {
      if (!val) {
        this.populatePaymentDetails(this.selectedPayment);
      }
    },
    '$store.state.clinicId': function () {
      this.paymentDetails = null;
      // Don't reset cartHasS4Products - let cart watcher/getCartItems handle it
      this.updateHoursOfOPeration(this.$store.state.operations);
      this.getClinicPaymentDetails();
      this.getClinicDetails(this.$store.state.clinicId);
      this.canCheckoutChecker();
      if (this.$store.state.clinic && this.$store.state.clinic.length) {
        this.shippingDetails = this.$store.state.clinic[0];

        this.showCreditCard =
          this.$store.state.clinic[0].paymentTypes.includes('creditCard');
        this.showBankAccount =
          this.$store.state.clinic[0].paymentTypes.includes('DebitCard');
      }

      if (this.cartItems.length && (this.active === 3 || this.active === 2)) {
        this.active = 1;
      }
      this.isUS = process.env.VUE_APP_REGION === 'US';
      if (this.isUS) this.getUSTax();
    },
    totalPrice: function(totalPrice) {
      // Skip limit check if payment method is credit card or payment terms
      if (!this.shouldApplyOrderLimit) {
        this.haveMeetMaximumOrderLimit = false;
        this.maximumOrderLimit = false;
        return;
      }
      
      if (Math.round(totalPrice) < this.MAX_ORDER_LIMIT && !this.firstLoad) this.haveMeetMaximumOrderLimit = false;
      if (
        (Math.round(totalPrice) > this.maxOrderLimitThreshold && this.firstLoad) ||
        Math.round(totalPrice) > this.maxOrderLimitThreshold && !this.haveMeetMaximumOrderLimit
      ) {
        this.maximumOrderLimit = true;
        this.firstLoad = false;
        this.haveMeetMaximumOrderLimit = true;
      }
    },
  },
  methods: {
    toPluralOperationsMap(val) {
      const pick = (obj, singular, plural) =>
        obj && obj[plural] != null ? obj[plural] : obj && obj[singular] != null ? obj[singular] : null;
      return {
        mondays: pick(val, 'monday', 'mondays'),
        tuesdays: pick(val, 'tuesday', 'tuesdays'),
        wednesdays: pick(val, 'wednesday', 'wednesdays'),
        thursdays: pick(val, 'thursday', 'thursdays'),
        fridays: pick(val, 'friday', 'fridays'),
        saturdays: pick(val, 'saturday', 'saturdays'),
        sundays: pick(val, 'sunday', 'sundays'),
      };
    },
    ...mapActions('ecommerce', [
      'getCartItemsFromApi',
      'paymentForCartItems',
      'fetchFailedPayments',
      'createMinimumOrder',
      'orderAgain',
      'fetchProductDetail',
    ]),
    ...mapActions('clinic', ['addNewPaymentMethod','fetchClinicsDetail']),
    ...mapActions('general', [
      'fetchUserDetails',
      'fetchCardDetails',
      'fetchCardDetailsList',
      'fetchClinicPaymentDetails',
      'taxJarCalculateOrderTax',
      'setDefaultPaymentMethod',
    ]),
    ...mapMutations('ecommerce', ['REMOVE_ALL_ITEMS_IN_CART', 'UPDATE_SHIPPING_FEE_CHECKER']),
    ...mapActions('storeProducts', ['fetchStoreLimitation']),
    ...mapActions('storeAlertNotification', ['fetchCheckoutStoreAlertsBanner']),
    ...mapActions('orderRequestApproval', ['createApprovalRequest']),
    toggleInactiveItems() {
      this.showInactive = !this.showInactive;
    },
    validateAllDays() {
      if (this.$refs.deliveryOperatingDays && this.$refs.deliveryOperatingDays.validateAllDays) {
        return this.$refs.deliveryOperatingDays.validateAllDays();
      }
      return true;
    },
    removeAllInactive() {
      this.inactiveCartItems.forEach(item => {
        this.$store.dispatch('eCommerce/removeInactiveItemFromCart', item);
      });
    },

    // FRH-747: PayTo's clinicPaymentOptions value is the literal string
    // 'PayTo' — unlike CreditCard/BankAccount, which map through
    // differently-cased legacy names (formattedType, below), it needs no
    // translation. Shared here rather than repeated inline everywhere this
    // entitlement is checked (radioButtonEnabled, hasPaymentTermSetup,
    // setDefaultPaymentType).
    isPayToEnabled() {
      return this.clinicPaymentOptions.some(e => e === 'PayTo');
    },
    formatPayToAddedDate(createdAt) {
      const parsed = moment(createdAt);
      return parsed.isValid() ? parsed.format('DD MMM YYYY, h:mm A') : '';
    },
    // The one place that knows how each payment-method shape maps to the
    // value selectedPayment/vs-value actually use — PayTo keys on its own
    // account id (no paymentMethodId until Active), a payment term keys on
    // value, everything else keys on cardId or paymentMethodId. Used by the
    // template's radio list and by setDefaultPaymentType below, so the two
    // can't drift apart the way they used to when this was three separate
    // inline ternaries.
    paymentMethodKey(method) {
      if (method.isPaymentTerm) return method.value;
      if (method.type === 'PayTo') return method.id;
      return method.cardId || method.paymentMethodId;
    },
    radioButtonEnabled(type, status) {
      // FRH-745: a Pending (not yet bank-approved) mandate is now
      // selectable too, matching Credit Card/Bank Account's lack of a
      // status gate — the clinic can add PayTo from this page's "Add
      // Payment Method" modal (still save-only there) and immediately
      // select the new Pending account here, submitting via the page's own
      // Confirm button. checkoutPayment creates a held order for it
      // instead of charging (see the PayTo branch there) if it's not yet
      // Active by the time Confirm is clicked. An explicit allowlist rather
      // than "anything but Inactive" — this gates a real payment action, so
      // a status this client doesn't yet know about should default to
      // unselectable, not selectable.
      if (type === 'PayTo') return ['Active', 'Pending'].includes(status) && this.isPayToEnabled();

      const formattedType = {
        'CreditCard': 'creditCard',
        'BankAccount': 'DebitCard',
      };

      return this.clinicPaymentOptions.length && this.clinicPaymentOptions.some(e => e === formattedType[type]);
    },
    async getClinicDetails() {
      try {
        const { data } = await this.fetchClinicsDetail(sessionStorage.getItem('doctorClinicSelectedClinic'));
        this.isDoctorStore = data.data.isDoctorStore;

        const { 
          orgOwner, 
          storeInvoiceEmail, 
          invoiceEmail, 
          doctorApprovalFlowEnabled, 
          isCreditCardFeeExempt, 
          paymentTypes,
        } = data.data;
        
        this.orgOwnerEmail = storeInvoiceEmail || 
                            (orgOwner ? (orgOwner.details.length > 0 ? orgOwner.details[0].email : null) : null) || 
                            invoiceEmail;

        this.isCreditCardFeeExempt = isCreditCardFeeExempt;
        this.clinicPaymentOptions = paymentTypes;
        
        // Store clinic's approval flow setting (computed property will use this)
        this.clinicApprovalFlowSetting = doctorApprovalFlowEnabled != null ? doctorApprovalFlowEnabled : false;
      } catch (error) {
        console.log(`Fetching clinic details: ${error}`);
      }
    },
    async canCheckoutChecker() {
      this.canCheckout = true;
      this.hasOustanding = false;
    },
    closePopup() {
      this.getClinicPaymentDetails();
    },
    populatePaymentDetails(val) {
      // Reset on every call — without this, switching from e.g. a saved
      // PayTo/BankAccount selection back to a CreditCard matched by
      // paymentMethodId (the branch below that never sets this itself)
      // left paymentType stuck at the previous selection's value, which
      // feeds both the checkout payload and analytics.
      this.paymentType = null;
      // A falsy val (nothing selected) must not fall through to the filters
      // below — a CreditCard entry with no paymentMethodId of its own (see
      // the cardId-matched branch just after) would match `undefined ===
      // undefined` and silently select the wrong payment method.
      if (!val) {
        this.paymentDetails = null;
        return;
      }
      let searchResult = this.paymentMethods.filter(
        ({ paymentMethodId, type }) =>
          paymentMethodId === val && type === 'CreditCard'
      );

      if (searchResult.length <= 0) {
        searchResult = this.paymentMethods.filter(
          ({ cardId, type }) => cardId === val && type === 'CreditCard'
        );
        if (searchResult.length) this.paymentType = 'CreditCard';
      }

      if (searchResult.length <= 0) {
        searchResult = this.paymentMethods.filter(
          ({ paymentMethodId, type }) =>
            paymentMethodId === val && type === 'BankAccount'
        );
        if (searchResult.length) this.paymentType = 'BankAccount';
      }
      if (searchResult.length <= 0) {
        // FRH-745: keyed on the account's own id, not paymentMethodId — a
        // Pending account (now selectable, see radioButtonEnabled) has no
        // paymentMethodId yet, only once it's actually Active.
        searchResult = this.paymentMethods.filter(
          ({ id, type }) =>
            id === val && type === 'PayTo'
        );
        if (searchResult.length) this.paymentType = 'PayTo';
      }
      if (searchResult.length <= 0) {
        searchResult = this.paymentMethods.filter(
          ({ value, isPaymentTerm }) =>
            value === val && isPaymentTerm
        );
      }

      if (searchResult.length) {
        this.paymentDetails = { ...searchResult[0] };
      } else {
        // A stale paymentDetails from a previous selection would otherwise
        // keep driving paymentEfficiencyBenefit's eligibility check after a
        // failed lookup (FRH-736/737) — previously only mis-rendered a badge.
        this.paymentDetails = null;
      }
    },
    getDeliveryCharge() {
      const items = this.$store.getters['eCommerce/items'];
      const {
        appliedCustomDeliveryFee,
      } = this.$store.getters['eCommerce/delivery'];
      
      this.deliveryFees = buildDeliveryFeeLines(items, appliedCustomDeliveryFee);

      // Recompute total from the grouped deliveryFees we actually display
      const computedTotal = this.deliveryFees.reduce(
        (sum, fee) => sum + Number(fee.amount || 0),
        0,
      );

      return computedTotal;
    },
    getTaxableSubtotal() {
      // Use the taxableSubTotal from mixin if available (it's the taxable amount before GST, not GST itself)
      if (this.taxableSubTotal && this.taxableSubTotal > 0) {
        // Return the taxable amount (before GST), not GST
        return this.taxableSubTotal;
      }

      // Fallback: calculate manually if taxableSubTotal is not available
      let subtotal = 0;
      this.cartItems.map((item) => {
        if (item.isTaxable) {
          let price = item.price;

          if (this.isLoggedInSuperAdmin && item.hasOwnProperty('superAdminPrice')) price = item.superAdminPrice * CENTS_PER_DOLLAR;

          if (this.isDiscounted(item)) {
            const rule = this.discountsArray.filter(discount => discount.productIds.some(id => id === item.productStoreId))[0].rule;

            // For tiered costing with fresh_price, use that directly (check this first)
            if (rule.fresh_price != null) {
              const freshPrice = this.getProductFreshPriceFromRule(rule, item.productStoreId);
              price = freshPrice * CENTS_PER_DOLLAR;
            } else {
              // has bulk discount rule & clinic discount, bulk discount < clinic discount

              // Determine base price source
              if (this.isLoggedInSuperAdmin && item.hasOwnProperty('superAdminDiscountPrice')) {
                price = item.superAdminDiscountPrice * CENTS_PER_DOLLAR;
              } else if (rule.discount_price === DISCOUNT_PRICE_LIST_PRICE) {
                price = item.listPrice;
              } else if (rule.discount_price === DISCOUNT_PRICE_DOCTOR_PRICE) {
                price = item.doctorPrice;
              }

              // Apply discount calculations
              if (rule.discount_type === 'percentage') {
                price = price - (price * (rule.discount_value / CENTS_PER_DOLLAR));
              } else if (rule.itemDiscount) {
                price = price - (rule.itemDiscount * CENTS_PER_DOLLAR);
              }
            }
          }
          if (this.hasPromo(item)) {
            const promo = this.applicablePromo.filter(promoItem=> promoItem.productIds.some(id=> id === item.productStoreId))[0];
            const rule = promo.rule;
            // Use getProductFreshPriceFromRule to get product-specific price if available
            if (rule.fresh_price != null) {
              const freshPrice = this.getProductFreshPriceFromRule(rule, item.productStoreId);
              price = freshPrice * CENTS_PER_DOLLAR;
            } else if (rule.fresh_price) {
              price = rule.fresh_price;
            }
            // If no fresh_price, the price should already be the discounted price from the mixin calculation
          }
          // Add the taxable amount (price * quantity), not GST
          subtotal += price * item.quantity;
        }
      });
      return subtotal;
    },
    isDiscounted(item) {
      return this.discountsArray.some(discount => discount.productIds.some(id => id === item.productStoreId));
    },
    hasPromo(item) {
      return this.applicablePromo.some(promo=> promo.productIds.some(id=> id === item.productStoreId));
    },
    getUSTax() {
      const data = {
        from_country: 'US',
        from_zip: this.shippingDetails.address.postCode,
        from_state: this.shippingDetails.address.state,
        from_city: this.shippingDetails.address.suburb,
        from_street: this.shippingDetails.address.displayAddress,
        amount: this.totalPrice / Math.pow(10, 2),
        shipping: '0',
        to_country: 'US',
        to_zip: this.shippingDetails.address.postCode,
        to_state: this.shippingDetails.address.state,
        to_city: this.shippingDetails.address.suburb,
        to_street: this.shippingDetails.address.displayAddress,
      };
      this.taxJarCalculateOrderTax(data)
        .then((res) => {
          this.tax = res.data.data.tax.amount_to_collect * CENTS_PER_DOLLAR;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setDefaultPaymentType(paymentMethods) {
      // FRH-745: a refetch (e.g. after saving a new PayTo account) must not
      // clobber a selection the clinic already made — only pick a default
      // when nothing is selected yet, or the current selection no longer
      // resolves to a still-selectable entry in the fresh list. "Still
      // selectable", not just "still present": a selected Pending PayTo
      // account that a refetch reveals has since gone Inactive must not
      // count as still existing, or the clinic is left with a selection
      // that no longer renders as a radio option and a permanently
      // disabled Confirm button, with nothing explaining why. Payment-term
      // entries have no radioButtonEnabled gate at all (the template always
      // shows them), so they're exempt from that check.
      if (this.selectedPayment) {
        const stillExists = paymentMethods.some(
          (method) =>
            this.paymentMethodKey(method) === this.selectedPayment &&
            (method.isPaymentTerm || this.radioButtonEnabled(method.type, method.status))
        );
        if (stillExists) return;
        // No longer selectable — clear it outright rather than leaving it
        // stale. What follows tries to pick a new default; if it can't (no
        // default set, nothing else eligible), this needs to stay null so
        // the page falls back to its normal empty "nothing selected" state,
        // instead of a Confirm button stuck disabled by a selection that no
        // longer renders anywhere and the clinic has no way to clear.
        this.selectedPayment = null;
      }
      const defaultValue = paymentMethods.filter(({ isDefault }) => isDefault);
      const formattedType = {
        'CreditCard': 'creditCard',
        'BankAccount': 'DebitCard',
      };
      let isNotHidden = defaultValue.length > 0 && this.clinicPaymentOptions.includes(formattedType[defaultValue[0].type]);
      if(isNotHidden) {
        this.selectedPayment = this.paymentMethodKey(defaultValue[0]);
      } else {
        /*
          check if clinic payment methods enabled
          it's not default and is not payment term
        */
        // FRH-747: PayTo is now gated on clinicPaymentOptions (isPayToEnabled),
        // same as CreditCard/BankAccount (formattedType) — without that check
        // here too, a clinic with a pre-existing Active mandate but no PayTo
        // entitlement (e.g. mid-rollout) would get it silently preselected
        // despite no visible radio for it (see radioButtonEnabled).
        // FRH-745: deliberately still Active-only here, unlike
        // radioButtonEnabled's Active-or-Pending — a Pending mandate is
        // selectable, but must never be *auto*-selected, since confirming
        // with one holds the order rather than charging it. That's a
        // deliberate choice for the clinic to make, not a default we pick
        // for them.
        const otherPaymentMethods = paymentMethods.filter(e => !e.isDefault && !e.isPaymentTerm && ((e.type === 'PayTo' && e.status === 'Active' && this.isPayToEnabled()) || this.clinicPaymentOptions.some(ee => ee === formattedType[e.type])));
        if (otherPaymentMethods.length) {
          this.selectedPayment = this.paymentMethodKey(otherPaymentMethods[0]);
        }
      }
    },
    getClinicPaymentDetails() {
      if (sessionStorage.getItem('doctorClinicSelectedClinic')) {
        this.fetchClinicPaymentDetails(
          sessionStorage.getItem('doctorClinicSelectedClinic')
        )
          .then((res) => {
            this.paymentMethods = res.data.data;
            this.setDefaultPaymentType(res.data.data);
            // FRH-745: re-derive paymentDetails against the fresh list too —
            // selectedPayment can stay the same id (e.g. a PayTo account)
            // while the underlying entry's status/paymentMethodId just
            // changed (Pending -> Active). paymentDetails is a snapshot
            // taken at selection time; without this it would keep posting a
            // stale copy (no paymentMethodId) to checkoutPayment, holding an
            // order that's actually chargeable by now.
            this.populatePaymentDetails(this.selectedPayment);
          })
          .catch((err) => {
            // capture if no org
            if (err && err.status === 400) {
              this.$vs.notify({
                title: 'Error',
                text: 'No Organisation assigned. Can\'t checkout/order.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
              });
            }
            console.log(err);
          });
      }
    },
    updateHoursOfOPeration(val) {
      if (val && Object.keys(val).length) {
        this.operations = toPluralOperationsMap(val);
      }
    },
    async onClick(val) {
      if (this.cartItems.length <= 0 && val === 2) {
        this.active = 1;
      } else if (val === 3) {
        if (!this.validateAllDays()) {
          return false;
        }
        if (!this.deliveryButtonDisabled) {
          this.active = val;

          trackEcommerceEvent(ADD_PAYMENT_INFO, {
            currency: getCurrency(),
            value: formatPriceValue(this.cartSubTotal),
            coupon: this.couponsList,
            payment_type: this.paymentType,
            items: this.cartItems.map((item) => ({
              item_id: item._id,
              item_name: item.name,
              price: formatPriceValue(item.price),
              quantity: item.quantity,
            })),
          });
        }
      } else if (this.cartItems.length > 0 && val === 2) {
        try {
          const validationPromises = this.cartItems.map(ci =>
            this.fetch_item_details(ci.productStoreId, ci.quantity, val)
          );
          const errorArrays = await Promise.all(validationPromises);
          const combinedErrors = [].concat(...errorArrays);
          if (combinedErrors.length === 0) {
            this.active = val;

            trackEcommerceEvent(ADD_SHIPPING_INFO, {
              currency: getCurrency(),
              value: formatPriceValue(this.cartSubTotal),
              coupon: this.couponsList,
              items: this.cartItems.map((item) => ({ item_id: item._id, item_name: item.name, price: formatPriceValue(item.price), quantity: item.quantity })),
            });
          }
        } catch (error) {
          console.log('error', error);
        }
      }
      else if (val !== 3) {
        this.active = val;
      }
    },
    clinicBankPaymentSuccess() {
      this.$vs.loading.close();
      this.popupActive = false;
      this.getClinicPaymentDetails();
    },
    payToSetupSuccess() {
      this.getClinicPaymentDetails();
    },
    openPopup() {
      this.popupActive = true;
      this.paymentType = 'CreditCard';
      this.selectedPayment = null;
      this.paymentDetails = null;

      const payment = this.clinicPaymentOptions;

      if (payment.includes('creditCard') && payment.includes('DebitCard')) {
        this.showBankAccount = true;
        this.showCreditCard = true;
      } else if (payment.includes('creditCard') && !payment.includes('DebitCard')) {
        this.showBankAccount = false;
        this.showCreditCard = true;
      } else if (!payment.includes('creditCard') && payment.includes('DebitCard')) {
        this.showBankAccount = true;
        this.showCreditCard = false;
      } else {
        this.showBankAccount = false;
        this.showCreditCard = false;
      }

    },
    goToOrders() {
      this.popupActive2 = false;
      setTimeout(() => {
        this.$router.push({ name: this.getRoleRouteName('OrderList') });
      }, 200);
    },
    getCartItems() {
      this.$vs.loading();
      this.getCartItemsFromApi(
        sessionStorage.getItem('doctorClinicSelectedClinic')
      ).then((res) => {
        const tempData = [...res.data.data];
        tempData.forEach(product => {
          this.quantity = product.quantity;
          this.checkItemQuantity(product.quantity, product);
        });
        this.$vs.loading.close();
        this.deliveryFees = [];
        this.getDeliveryCharge();
      });
    },
    submit() {
      this.$vs.loading();
      this.$refs.stripeElement.submit();
      this.isCreditCard = true;
    },
    errorMessage(error) {
      this.$vs.loading.close();
      this.$vs.notify({
        title: '',
        text: error.message,
        color: 'danger',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      });
    },
    extractErrorDetails(error) {
      // Extract error title and message from API error response structures
      // only. Deliberately no fallback to error.message: for non-API errors
      // (a TypeError in a .then, a Stripe.js IntegrationError) that is
      // developer-facing text and must not be shown to users.
      let errorTitle = DEFAULT_ERROR_TITLE;
      let errorMessage = DEFAULT_PAYMENT_ERROR_MESSAGE;
      
      if (error && error.data && error.data.title) {
        errorTitle = error.data.title;
      } else if (error && error.response && error.response.data && error.response.data.title) {
        errorTitle = error.response.data.title;
      }
      
      if (error && error.data && error.data.message) {
        errorMessage = error.data.message;
      } else if (error && error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      
      return { errorTitle, errorMessage };
    },
    tokenCreated(token) {
      const updater = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
      );
      const data = {
        updater: updater.firstName + ' ' + updater.lastName,
        name: this.shippingDetails.clinicName,
        updatedFields: {
          card: {
            oldValue: '', newValue: `${token.card.brand} (XXXX XXXXXXXX ${token.card.last4})`,
          }, 
        },
      };
      this.addNewPaymentMethod({
        data,
        token,
        clinicId: sessionStorage.getItem('doctorClinicSelectedClinic'),
        intentId: null,
      })
        .then((res) => {
          const data = res.data.data;
          if (!data.success) {
            this.$vs.notify({
              title: '',
              text: res.data.data.message,
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
            });
          }
          this.getClinicPaymentDetails();
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.log(err);
        });
    },
    confirmPayment(response, charge) {
      this.$vs.loading.close();
      this.stripe.handleCardAction(response.payment_intent_client_secret).then(result => {
        if (result.error) {
          this.$vs.notify({
            // result.error.message is Stripe's customer-facing decline text.
            title: PAYMENT_FAILED_TITLE,
            text: result.error.message
              || 'We couldn\'t verify your card. Please try again or use a different payment method.',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          // Show error in payment form
        } else {
          this.sendToServer(charge, result.paymentIntent);
        }
      }).catch((error) => {
        console.error(error);
        const { errorMessage } = this.extractErrorDetails(error);
        this.$vs.notify({
          title: PAYMENT_FAILED_TITLE,
          text: errorMessage,
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
      });
    },
    addSIfNotEndsWithS(obj) {
      const newObj = {};
      for (let key in obj) {
        let newKey = key;
        if (!key.endsWith('s')) {
          newKey += 's';
        }
        newObj[newKey] = obj[key];
      }
      return newObj;
    },
    async saveClinicOpeningHours(clinicId, operations) {
      try {
        await this.$store.dispatch(
          'clinic/updateOpeningHours',
          {
            id: clinicId,
            data: {
              clinicOpeningHours: this.addSIfNotEndsWithS(operations),
            },
          }
        );
      } catch (error) {
        console.log(error.message);
      }
    },
    getMinimumQTy(item) {
      return item.inventory.requiredQuantity;
    },

    async sendToServer(charge, paymentIntent = {}) {
      // Check if smartlook is integrated in the project
      if (window.smartlook) {
        window.smartlook('track', 'storeorders', this.checkDeviceType);
      }
      // Send to charge to your backend server to be processed
      // Documentation here: https://stripe.com/docs/api/charges/create
      this.saveClinicOpeningHours(sessionStorage.getItem('doctorClinicSelectedClinic'), this.operations);
      this.$vs.loading();
      let data = {
        charge: charge,
        shippingDetails: this.shippingDetails,
        paymentDetails: this.paymentDetails,
        operations: this.operations,
        creditCardTransactionFee: this.creditCardTransactionFee,
        deliveryFees: this.deliveryFees,
        ...paymentIntent,
      };

      if (this.voucher) {
        data.voucher = {
          voucherId: this.voucher._id,
          totalDiscount: this.voucherPrice,
          discountName: this.voucher.voucher_code,
          discountLabel: this.voucher.discount_title,
          applyAfterGST: this.voucher.applyAfterGST,
        };
      }

      if (this.paymentType) {
        data = { ...data, paymentType: this.paymentType };
      }

      const selectedIds = JSON.parse(localStorage.getItem('selectedIds'));
      // append adminSelectedStaff if super-admin
      if (selectedIds && selectedIds.staffId && this.isLoggedInSuperAdmin) {
        data.adminSelectedStaff = selectedIds.staffId.userId;
      }

      // append sendToSage to process sage & send PO to supplier
      if (this.isLoggedInSuperAdmin) {
        data.sendToSage = this.sendToSage;
      }
      
        // Check if user type is doctor or approval flow is disabled
        if (currentUserIsDoctor() || !this.shouldShowDoctorApprovalFlow) {
          await this.paymentForCartItems({ ...data })
          .then(async (response) => {
            if (response.requires_action) {
              this.confirmPayment(response, charge);
            } else {
              this.$vs.loading.close();

              let payload = _.compact(this.cartItems.map((item) => {
                const isMatch = this.openingOrderSuppliers.find((i) => i === item.inventory.managedBy);
                if (isMatch && !item.openingOrder) return {
                  supplierId: item.inventory.managedBy,
                  clinicId: sessionStorage.getItem('doctorClinicSelectedClinic'),
                };
                return undefined;
              }));

              if (payload.length) {
                await this.createMinimumOrder({
                  order: _.uniqBy(payload, 'supplierId'),
                });
              }

              this.active = 3;
              this.popupActive = false;
              this.REMOVE_ALL_ITEMS_IN_CART();
              // FRH-745: a PayTo checkout that's still Pending doesn't charge
              // anything yet — checkoutPayment holds the order for the
              // webhook to resolve once the bank approves (or declines) it.
              // Telling the clinic "success" here would be misleading; the
              // backend's own title/message are written for the instant-
              // charge case only. The server's own isAwaitingPayToMandate is
              // authoritative (it's re-checked the account's real status,
              // possibly racing the same webhook that could resolve it
              // between our last refetch and this response) — isPayToHold is
              // only a fallback for a response that predates this field.
              // Not `||` — isAwaitingPayToMandate can legitimately be `false`
              // (a synchronous charge), and `||` would wrongly fall back to
              // the client guess for that case. Only fall back when the
              // server hasn't sent this field at all (an older response).
              const serverIsHeld = response.data.data.newOrder.isAwaitingPayToMandate;
              const isHeld = typeof serverIsHeld === 'boolean' ? serverIsHeld : this.isPayToHold;
              this.$vs.notify(
                isHeld
                  ? {
                      title: ORDER_COMPLETE_MESSAGES.TITLE.PAYTO_PENDING,
                      text: ORDER_COMPLETE_MESSAGES.MESSAGE.PAYTO_PENDING,
                      color: 'warning',
                      iconPack: 'feather',
                      icon: 'icon-clock',
                    }
                  : {
                      title: response.data.title,
                      text: response.data.message,
                      color: 'success',
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                    },
              );

              // Don't record a purchase conversion for an order that isn't
              // actually paid yet — if the PayTo mandate is later declined,
              // this would otherwise inflate revenue reporting with money
              // that was never collected.
              if (!isHeld) {
                trackEcommerceEvent(PURCHASE, {
                  currency: getCurrency(),
                  value: formatPriceValue(this.cartSubTotal),
                  transaction_id: response.data.data.newOrder._id,
                  coupon: this.couponsList,
                  shipping: formatPriceValue(this.deliveryCharge),
                  tax: formatPriceValue(this.gstTotal),
                  items: this.cartItems.map((item) => {
                    return {
                      item_id: item._id,
                      item_name: item.name,
                      price: formatPriceValue(item.price),
                      quantity: item.quantity,
                    };
                  }),
                });
              }

              if (this.$store.state.AppActiveUser.userType === 'superAdmin') {
                this.$router.push({
                  name: 'superAdminStoreViewOrder',
                  params: {
                    orderId: response.data.data.newOrder._id,
                  },
                });
              } else {
                this.$router.push({
                  name: this.getRoleRouteName('OrderComplete'),
                  query: {
                    orderNumber: response.data.data.newOrder.orderNumber,
                    orderId: response.data.data.newOrder._id,
                    doctorApprovalFlow: this.shouldShowDoctorApprovalFlow,
                    // Presentational only — drives which copy Order Complete
                    // shows, not any actual order state (that page has its
                    // own orderId to look the real thing up by if it needs to).
                    payToPending: isHeld,
                  },
                });
              }
            }

          })
          .catch((error) => {
            // FRH-739: error.data was assumed to always exist — if a request
            // fails in a shape that doesn't carry it (no response reached
            // the client, or a rejection from somewhere other than the
            // respondError'd API call), reading error.data.title threw here
            // and the whole catch silently died: loading spinner never
            // closed, no notification ever shown, no order created. This
            // guarantees the user always sees something.
            // Fall back per-field, not per-object — error.data can exist but
            // be empty (a common proxy/gateway error shape), which the
            // previous object-level fallback let straight through as
            // undefined title/text.
            console.error(error);
            const errorData = {
              title: (error && error.data && error.data.title) || DEFAULT_ERROR_TITLE,
              message:
                (error && error.data && error.data.message) ||
                DEFAULT_PAYMENT_ERROR_MESSAGE,
            };
            if (['CreditCard', 'StoredCard'].includes(this.paymentType)) {
              this.$vs.loading.close();
              this.$vs.notify({
                title: errorData.title,
                text: errorData.message,
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
              });
            } else if (errorData.title === 'Payment Intent Fail') {
              this.$vs.loading.close();
              this.$vs.notify({
                title: errorData.title,
                text: errorData.message,
                color: 'danger',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
              });
            } else {
              if (errorData.title === 'OUTSTANDING_PAYMENT') {
                this.$vs.loading.close();
                this.popupActive2 = true;
                return;
              } else {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: errorData.title,
                  text: errorData.message,
                  color: 'danger',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                });
                // Don't redirect on error - keep user on checkout page
              }
            }
          });
      } else {
        try {
          const {requestId} = this.$route.params;
          const res = await this.createApprovalRequest({
            checkoutPaymentPayload: data,
            clinicId: this.clinicId,
            requesterId: this.$store.state.AppActiveUser.id,
            parentRequestId: requestId ? requestId : null,
          });

          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Success',
            text: 'Approval request created successfully.',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check-circle',
          });

          if (this.$store.state.AppActiveUser.userType === 'superAdmin') {
            this.$router.push({
              name: 'superAdminStoreOrders',
              query: { tab: 2 },
            });
          } else {
            this.$router.push({
              name: this.getRoleRouteName('OrderComplete'),
              query: {
                requestNumber: res.data.data.requestNumber,
                requestId: res.data.data._id,
              },
            });
          }

          this.REMOVE_ALL_ITEMS_IN_CART();
        } catch (error) {
          console.error('Error creating approval request:', error);

          this.$vs.loading.close();
          this.$vs.notify({
            title: (error && error.data && error.data.title) || 'Error',
            text:
              (error && error.data && error.data.message) ||
              'Failed to create approval request. Please try again later.',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
        }
      }

    },
    checkItemQuantity(quantity, data) {
      const { requiredQuantity, maxQuantity } = data.inventory;
      const itemId = data._id;

      // Check if the quantity is less than the required quantity
      if (this.quantity < requiredQuantity) {
        this.errors.add({
          field: 'MinimumQuantityLimit',
          msg: `Minimum order quantity is ${requiredQuantity}`,
          id: itemId,
        });
        this.$vs.notify({
          title: 'Failed',
          text: `Minimum quantity for order is ${requiredQuantity}`,
          color: 'danger',
        });
      } else {
        this.errors.remove('MinimumQuantityLimit');
      }

      // Check if the quantity is greater than the maximum quantity
      if (maxQuantity !== null && maxQuantity !== 0) {
        if (this.quantity > maxQuantity) {
          this.errors.add({
            field: 'MaximumQuantityLimit',
            msg: `Maximum quantity for order is ${maxQuantity}`,
            id: itemId,
          });
          this.$vs.notify({
            title: 'Failed',
            text: `Maximum quantity for order is ${maxQuantity}`,
            color: 'danger',
          });
        } else {
          this.errors.remove('MaximumQuantityLimit');
        }
      }
    },
    async nextTab() {
      let isValid = await this.$validator.validateAll('basic');
      if (!isValid) {
        this.$vs.notify({
          title: 'Error',
          text: 'Validation Failed',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
        return false;
      }
      this.$refs.checkoutWizard.nextTab();
    },
    savedClinicBankPayment() {
      this.$vs.loading();

      this.paymentForCartItems({
        charge: this.totalPrice,
        shippingDetails: this.shippingDetails,
        paymentType: 'SavedClinicBankAccount',
      })
        .then((res) => {
          this.REMOVE_ALL_ITEMS_IN_CART();
          this.active1 = true;
          this.$vs.notify({
            title: res.data.title,
            text: res.data.message,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          this.$router.push({
            name: this.getRoleRouteName('OrderComplete'),
            query: {
              orderNumber: res.data.data.newOrder.orderNumber,
              orderId: res.data.data.newOrder._id,
            },
          });

          trackEcommerceEvent(PURCHASE, {
            currency: getCurrency(),
            value: formatPriceValue(this.cartSubTotal),
            transaction_id: res.data.data.newOrder._id,
            coupon: this.couponsList,
            shipping: formatPriceValue(this.deliveryCharge),
            tax: formatPriceValue(this.gstTotal),
            items: this.cartItems.map((item) => {
              return {
                item_id: item._id,
                item_name: item.name,
                price: formatPriceValue(item.price),
                quantity: item.quantity,
              };
            }),
          });

          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          // Don't clear cart or redirect on error - keep user on checkout page
          const { errorTitle, errorMessage } = this.extractErrorDetails(error);
          
          this.$vs.notify({
            title: errorTitle,
            text: errorMessage || 'An error occurred while processing your payment. Please try again.',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
        });
    },
    async getUserDetail() {
      const userDetail = await this.fetchUserDetails();

      if (userDetail.data.data.clinicOpeningHours) {
        const sched = { ...userDetail.data.data.clinicOpeningHours };
        delete sched._id;
        this.operations = {
          monday: sched.mondays,
          tuesday: sched.tuesdays,
          wednesday: sched.wednesdays,
          thursday: sched.thursdays,
          friday: sched.fridays,
          saturday: sched.saturdays,
          sunday: sched.sundays,
        };
      }

      return this.formatUserDetailResponse(userDetail.data.data);
    },
    formatUserDetailResponse(userDetail) {
      return {
        clinicName: userDetail.clinicName,
        address: userDetail.address,
        email: userDetail.email,
      };
    },
    // TAB 1
    removeItemFromCart(item) {
      this.$store.dispatch('eCommerce/toggleItemInCart', item);
      setTimeout(() => {
        this.getCartItems();
      }, 500);
    },
    wishListButtonClicked(item) {
      // Toggle in Wish List
      if (this.isInWishList(item.objectID))
        this.$router.push('/apps/eCommerce/wish-list').catch(() => { });
      else {
        this.toggleItemInWishList(item);
        this.removeItemFromCart(item);
      }
    },
    toggleItemInWishList(item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item);
    },
    increase(item) {
      item.quantity = Math.trunc(item.quantity);

      return _.debounce(() => {

        // if script product, do not update cart
        if (item.patient !== undefined) {
          return;
        }

        // Disable input first
        this.disableInput = true;

        setTimeout(() => {
          this.disableInput = false;
        }, 0);
        // Declare variables
        let cloneCart = _.cloneDeep(this.cartItems);
        let index = _.findIndex(cloneCart, { _id: item._id });

        // Checking if required quantity is met
        if (item.quantity < item.inventory.requiredQuantity) {
          this.errors.add({
            field: 'MinimumQuantityLimit',
            msg:
              'Minimum quantity for order is ' +
              item.inventory.requiredQuantity,
            id: item._id,
          });
          this.$vs.notify({
            title: 'Failed',
            text: 'Minimum quantity for order is ' + item.inventory.requiredQuantity,
            color: 'danger',
          });
          return;
        }

        // Check if its more than max quantity
        if (item.inventory.maxQuantity > 0 && item.quantity > item.inventory.maxQuantity) {
          this.errors.add({
            field: 'MaximumQuantityLimit',
            msg:
              'Maximum quantity for order is ' + item.inventory.maxQuantity,
            id: item._id,
          });
          this.$vs.notify({
            title: 'Failed',
            text: 'You\'ve exceeded maximum order amount.',
            color: 'danger',
          });
          return;
        }

        // 1. Check if its emtpy
        // 2. Check if its less than 1
        if (!cloneCart[index].quantity || cloneCart[index].quantity < 1) {
          this.cartItems[index].quantity = 1;
          item.quantity = 1;
          cloneCart[index].quantity = 1;
          this.errors.add({
            field: 'MinimumQuantityLimit',
            msg: 'Minimum quantity for order is 1',
            id: item._id,
          });
        }

        // Check if its more than 999
        if (cloneCart[index].quantity > 999) {
          this.cartItems[index].quantity = 999;
          cloneCart[index].quantity = 999;
          this.errors.add({
            field: 'MaximumQuantityLimit',
            msg: 'Maximum quantity for order is 999',
            id: item._id,
          });
        }

        this.errors.removeById(item._id);

        // convert to original
        if (item.hasOwnProperty('superAdminPrice')) item.adjustedPrice = item.superAdminPrice * CENTS_PER_DOLLAR;
        if (item.hasOwnProperty('superAdminDiscountPrice') && this.isDiscounted(item)) item.adjustedDiscountPrice = item.superAdminDiscountPrice * CENTS_PER_DOLLAR;

        // remove keys superAdminDiscountPrice if not discounted
        if (item.hasOwnProperty('superAdminDiscountPrice') && !this.isDiscounted(item)) {
          delete item.superAdminDiscountPrice;
          delete item.adjustedDiscountPrice;
          delete item.superAdminDiscountPriceFrom;
        }

        this.$store.dispatch('eCommerce/updateItemQuantity', {
          item: item,
        });
        setTimeout(() => {
          this.getCartItems();
        }, 500);
      }, 500)();

    },
    decrease(item) {
      const _id = item._id;
      if (item.patient === undefined) {
        let cloneCart = _.cloneDeep(this.cartItems);
        let index = _.findIndex(cloneCart, { _id });

        let item = cloneCart[index];

        if (item.quantity < item.inventory.requiredQuantity) {
          this.errors.add({
            field: 'MinimumQuantityLimit',
            msg:
              'Minimum quantity for order is ' +
              item.inventory.requiredQuantity,
            id: item._id,
          });
        } else {
          this.errors.removeById(item._id);
          this.$store.dispatch('eCommerce/updateItemQuantity', {
            item: item,
          });
        }
        if (
          item.inventory.maxQuantity !== null &&
          item.inventory.maxQuantity !== 0
        ) {
          if (item.quantity > item.inventory.maxQuantity) {
            this.errors.add({
              field: 'MaximumQuantityLimit',
              msg:
                'Maximum quantity for order is ' + item.inventory.maxQuantity,
              id: item._id,
            });
          }
        }
      }
    },
    async reOrderItems(orderId) {
      try {
        this.$vs.loading();
        const res = await this.orderAgain({ orderId });
        const { data: { data } } = res;
        if (res.status === 200) {
          // Clear orderId when reorder succeeds
          localStorage.removeItem('orderId');
          setTimeout(() => {
            this.getCartItems();
          }, 500);
          // check
          data.forEach(item => {
            this.quantity = item.quantity;
            this.checkItemQuantity(item.quantity, item);
          });
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    async fetch_item_details(productId, quantity) {
      let localErrors = [];
      try {
        this.$vs.loading();
        const response = await this.fetchProductDetail(productId);
        const item = response.data.data.product;

        if (quantity < item.inventory.requiredQuantity) {
          localErrors.push({
            field: 'MinimumQuantityLimit',
            msg:
              'Minimum quantity for order is ' +
              item.inventory.requiredQuantity,
            id: item._id,
          });
          this.errors.add({
            field: 'MinimumQuantityLimit',
            msg:
              'Minimum quantity for order is ' +
              item.inventory.requiredQuantity,
            id: item._id,
          });
          this.$vs.notify({
            title: 'Failed',
            text: `Minimum quantity for order is ${item.inventory.requiredQuantity}`,
            color: 'danger',
          });
        }

        if (
          item.inventory.maxQuantity !== null &&
          item.inventory.maxQuantity !== 0
        ) {
          if (quantity > item.inventory.maxQuantity) {
            localErrors.push({
              field: 'MaximumQuantityLimit',
              msg:
                'Maximum quantity for order is ' + item.inventory.maxQuantity,
              id: item._id,
            });
            this.errors.add({
              field: 'MaximumQuantityLimit',
              msg:
                'Maximum quantity for order is ' + item.inventory.maxQuantity,
              id: item._id,
            });
            this.$vs.notify({
              title: 'Failed',
              text: `Maximum quantity for order is ${item.inventory.maxQuantity}`,
              color: 'danger',
            });
          }
        }

        this.$vs.loading.close();
        return localErrors;

      } catch (error) {
        this.$vs.loading.close();
      }
    },
  },
  components: {
    CheckoutListView,
    FormWizard,
    Tabs,
    XIcon,
    SwapClinic,
    CheckoutVoucher,
    ImportantInformation,
    DeliveryOperatingDays,
    AddPaymentMethod,
  },
  beforeMount: async function () {
    if (
      localStorage.getItem(`${process.env.VUE_APP_PROCESS_TOKEN}OrganizationId`)
    ) {
      this.hasOrganization = true;
    }
    this.limitationsList = this.$store.state.currentStoreLimitation;
    this.role = localStorage.getItem(
      `${process.env.VUE_APP_PROCESS_TOKEN}Role`
    );
  },
  async mounted() {
    const clinicId = sessionStorage.getItem('doctorClinicSelectedClinic');
    this.orderApprovalFlowEnabled = await this.$isClinicOrderApprovalFlowEnabled(clinicId);
    
    // Skip doctorApprovalFlowEnabled flag if user is doctor
    if (currentUserIsDoctor()) {
      this.orderApprovalFlowEnabled = false;
    }
    
    if (this.orderApprovalFlowEnabled) {
      this.thisCartText = 'This Inventory Forecast is for:';
    }
  },
};
</script>

<style lang="scss">
.voucher-card {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: .25rem;
}

.inputNumber {
  margin: 5px;
  background: #f5f5f5;
  padding: 5px 15px;
  border-radius: 5px;
}

#ecommerce-checkout-demo {
  .increment-buttons {
    height: 42px;
    background: #3cc9b230;
    width: 100px;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
      }
    }
  }

  .add-new-address-form {
    ::v-deep .con-text-validation .span-text-validation {
      display: none;
    }
  }


  @media (min-width: 1024px) {
    .increment-buttons {
      border-radius: 5px;
    }

    .remove-button {
      border-radius: 5px;
    }
  }
}

.learnMorePopup .vs-popup {
  width: 50%;
}

.savings {
  background: #EBF7F4;
}

.delivery-text {
  color: rgba(38, 41, 40, 0.65);
}

.price-text {
  color: rgba(38, 41, 40, 1);
}

.circle {
  top: 10px;
  right: 10px;
}
</style>
